module.exports = __webpack_public_path__ + "img/evse_item.9791fc98.svg";